/**
 * Header — una línea de 40 px (2026-10-12, propuesta A elegida por Elvio): "Rx · Asistente de
 * farmacia · <sucursal>" a la izquierda (tocar la sucursal la cambia), "uso" y "salir" a la derecha.
 * Sin selector de modo (Conversación se quitó) ni "+": "Nuevo cliente →" va al pie de cada respuesta.
 */
import { leerSucursal, olvidarSucursal } from '../hooks/useSucursal'
import { cerrarSesion, esAdmin, leerSesion } from '../utils/sesion'

export function Header() {
  const sucursal = leerSucursal()
  const sesion = leerSesion()
  return (
    <header className="barra">
      <span className="barra-rx" aria-hidden="true">Rx</span>
      <span className="barra-titulo">Asistente de farmacia</span>
      <span className="barra-sep" aria-hidden="true">·</span>
      {sucursal ? (
        <button
          type="button"
          className="barra-sucursal"
          title="Cambiar de sucursal"
          aria-label={`Sucursal ${sucursal.nombre}: cambiar`}
          onClick={() => {
            olvidarSucursal()
            window.location.reload()
          }}
        >
          {sucursal.nombre}
          <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"
            strokeLinecap="round" aria-hidden="true"><path d="M6 9l6 6 6-6" /></svg>
        </button>
      ) : (
        <span className="barra-sep">mostrador</span>
      )}
      <span className="flex-1" />
      {esAdmin() && (
        <button type="button" className="barra-link" title="Tablero de uso del asistente"
          onClick={() => { window.location.hash = 'uso' }}>
          uso
        </button>
      )}
      {sesion && (
        <button type="button" className="barra-link suave" title={`Salir (${sesion.email})`}
          onClick={() => cerrarSesion()}>
          salir
        </button>
      )}
    </header>
  )
}
